import { i18n } from "vue-lang-router";

export class MarketingHome {

  seo?: Seo;
  featured?: unknown;
  slider?: Slider[];
  universes?: Univers[];

  public static of(data: any): MarketingHome {
    const content: MarketingHome = new MarketingHome();

    content.featured = {
      title: data.marketing_featured_title,
      link: data.marketing_featured_link,
      image: data.marketing_featured_image || "",
      description: data.marketing_featured_description,
    };
    content.slider = data.marketing_homepage_slider.map(s => {
      return Slider.of(s);
    });
    content.universes = data.marketing_homepage_universes.map(s => {
      return Univers.of(s);
    });

    content.seo = Seo.of(data);
    return content;
  }
}

export class Seo {
  title?: string | null;
  description?: string | null;

  public static of(data: any): Seo {
    const s: Seo = new Seo();
    s.title = data?.marketing_homepage_seo_title;
    s.description = data?.marketing_homepage_seo_description;
    return s;
  }
}

export class BestSellers {
  title?: string | null;
  description?: string | null;
  products?: string | null;

  public static of(data: any): BestSellers {
    const s: BestSellers = new BestSellers();
    s.title = data?.marketing_bestsellers_title || null;
    s.description = data?.marketing_bestsellers_description || null;
    s.products = data?.marketing_bestsellers_products.replaceAll("|", ",") || "";
    return s;
  }
}

export class Universe {
  universes?: Univers[];
  description?: string | null;
  title?: string | null;

  public static of(data: any): Universe {
    const u: Universe = new Universe();
    u.title = data?.marketing_homepage_universes_title;
    u.description = data?.marketing_homepage_universes_description;
    u.universes = data?.marketing_homepage_universes.map(s => {
      return Univers.of(s);
    });

    return u;
  }
}

export class Sliders {
  sliders?: Slider[];

  public static of(data: any): Sliders {
    const u: Sliders = new Sliders();
    u.sliders = data.marketing_homepage_slider.map(s => {
      return Slider.of(s);
    });
    return u;
  }
}

export class Univers {
  size?: string | null;
  title?: string | null;
  link?: string | null;
  image?: any | null;

  public static of(data: any): Univers {
    const s: Univers = new Univers();

    switch (data?.dataBlockTitle) {
      case "Grand bloc (gauche)":
        s.size = "full";
        s.image = {
          desktop: data?.marketing_homepage_universes_block_image[0]?.url || "",
          mobile: data?.marketing_homepage_universes_block_image[0]?.url || "",
        };
        break;
      case "Bloc (haut-droite)":
        s.size = "half";
        s.image = {
          desktop: data?.marketing_homepage_universes_block_image[0]?.url || "",
          mobile: data?.marketing_homepage_universes_block_image[0]?.url || "",
        };
        break;
      case "Petit bloc (gauche)":
        s.size = "small1";
        s.image = {
          desktop: data?.marketing_homepage_universes_block_image[0]?.url || "",
          mobile: data?.marketing_homepage_universes_block_image[0]?.url || "",
        };
        break;
      case "Petit bloc (droite)":
        s.size = "small2";
        s.image = {
          desktop: data?.marketing_homepage_universes_block_image[0]?.url || "",
          mobile: data?.marketing_homepage_universes_block_image[0]?.url || "",
        };
        break;

    }

    s.title = data?.marketing_homepage_universes_block_title || "";
    s.link = data?.marketing_homepage_universes_block_link || "";
    return s;
  }
}

export class Slider {
  description?: string | null;
  title?: string | null;
  link?: string | null;
  image?: Record<string, unknown>;
  label?: string | null;
  enabled?: boolean;
  targets?: string[];

  public static of(data: any): Slider {
    const s: Slider = new Slider();
    s.description = data?.marketing_homepage_slider_block_description || null;

    const titleEntry = data?.marketing_homepage_slider_block_titre;
    let titleOut = "";
    if (titleEntry) {
      const linebreak = titleEntry.split("##BR##");

      linebreak.forEach((value, i) => {
        if (linebreak.length - 1 === i) {
          titleOut += value;
        } else {
          titleOut += value + "</br>";
        }
      });
      s.title = titleOut || null;
    } else {
      s.title = null;
    }
    s.link = data?.marketing_homepage_slider_block_link || null;
    s.label = data?.marketing_homepage_slider_block_button_label || i18n.t("Discover");
    s.image = {
      desktop: {
        url: data?.marketing_homepage_slider_block_image[0]?.url || "/assets/images/fd_blanc.webp",
        alt: data?.marketing_homepage_slider_block_image[0]?.alt || "",
      }, mobile: {
        url: data?.marketing_homepage_slider_block_image[0]?.url || "/assets/images/fd_blanc.webp",
        alt: data?.marketing_homepage_slider_block_image[0]?.alt || "",
      },
    };
    s.enabled = !!data?.marketing_homepage_slider_block_enabled;
    s.targets = data?.marketing_homepage_slider_block_target_websites;
    return s;
  }
}

export class Featured {
  description?: string | null;
  title?: string | null;
  link?: string | null;
  image?: any;
  label?: string | null;

  public static of(data: any): Featured {
    const f: Featured = new Featured();
    f.title = data.marketing_featured_title;
    f.link = data.marketing_featured_link;
    f.image = data.marketing_featured_image || "";
    f.description = data.marketing_featured_description;
    f.label = data.marketing_featured_button_label || i18n.t("I crave");
    return f;
  }
}

export class MarketingCategory {
  footer?: Record<string, unknown>;
  header?: Record<string, unknown>;
  seo?: Record<string, unknown>;
  featuredProducts?: string[] | null;

  public static of(data: any): MarketingCategory {
    const c: MarketingCategory = new MarketingCategory();
    c.header = {
      description: data?.marketing_landing_header_description || "",
      image: {
        "alt": data?.marketing_landing_header_image[0]?.alt || "shopping Air France",
        "url": data?.marketing_landing_header_image[0]?.url || "",
      },
      mobile: {
        "alt": data?.marketing_landing_header_image_mobile[0]?.alt || "shopping Air France",
        "url": data?.marketing_landing_header_image_mobile[0]?.url || "",
      },
    };
    c.footer = {
      description: data?.marketing_landing_footer_description || "",
      image: data?.marketing_landing_footer_image[0] ? {
        "alt": data?.marketing_landing_footer_image[0]?.alt || "shopping Air France",
        "url": data?.marketing_landing_footer_image[0]?.url || "",
      } : null,
    };
    c.seo = {
      title: data?.marketing_landing_seo_title || "",
      description: data?.marketing_landing_seo_description || "",
    };
    c.featuredProducts = data?.marketing_landing_menu_featured_products;
    return c;
  }
}
